import { VersionRange } from '../../models/core/version-range.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class SeatingSettingsComponent extends Component {
  static readonly TYPE_ID: string = 'dd6a0dbc7dcb47fe95accd94d0f2b9f5';
  static readonly SCHEMA_VERSION: number = 2;

  constructor(
    public readonly roomId: string,
    public readonly seatingLayoutId: string,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return SeatingSettingsComponent.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.between(1, SeatingSettingsComponent.SCHEMA_VERSION);
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatingSettingsComponent {
    return new SeatingSettingsComponent(
        MapUtils.get<string>(map, 'roomId'),
        MapUtils.get<string>(map, 'seatingLayoutId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'roomId': this.roomId,
      'seatingLayoutId': this.seatingLayoutId,
    };
  }

  clone(): this {
    return new SeatingSettingsComponent(
        this.roomId,
        this.seatingLayoutId,
    ) as this;
  }

  isSame(other: SeatingSettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.roomId == this.roomId &&
        other.seatingLayoutId == this.seatingLayoutId;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof SeatingSettingsComponent;
  }

  static assertType(order: DataModel): order is SeatingSettingsComponent {
    return order instanceof SeatingSettingsComponent;
  }
}

export class SeatingSettingsComponentBuilder extends DataModelBuilder<SeatingSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): SeatingSettingsComponent {
    return SeatingSettingsComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);
    if(versionRange.contains(SeatingSettingsComponent.SCHEMA_VERSION)) {
      return map;
    }
    if(versionRange.isGreaterThan(SeatingSettingsComponent.SCHEMA_VERSION)) {
      return null; // This data comes from the FUTURE. We have no idea how to migrate it.
    }

    let version = versionRange.to;

    if(version < 2) {
      map['roomId'] = map['seatingLayoutId'];
      version = 2;
    }

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
